<template>
	<div>
		<div class="OrderComplaint-list">
				<b-table id="delivery-list-table"
					:fields="orderComplaintTab.orderComplaintFields"
					:items="orderComplaintTab.complaintList"
					small
					bordered
					hover
					show-empty
					empty-text="当前没有售后信息"
					caption-top
					:busy="orderComplaintTab.isTableBusy">
					<template v-slot:cell(complainType)="row">
					    <span v-if="row.item.complainType === 1" >数量</span>
					    <span v-else-if="row.item.complainType === 2" >品质</span>
					    <span v-else-if="row.item.complainType === 3" >品种</span>
					    <span v-else>其他</span>
					</template>
					<template v-slot:cell(complainSendTime)="row">
						<span>{{formatDateTimeString(row.item.complainSendTime).substring(0,10)}}</span>
					</template>
					<template v-slot:cell(complainResponseTime)="row">
						<span>{{formatDateTimeString(row.item.complainResponseTime).substring(0,10)}}</span>
					</template>
					<template v-slot:cell(complainTips)="row">
					    <span v-if="row.item.complainResult ==='有责，赔付'" style="color: red;" >提示:退款的款项请查看往来账目</span>
					</template>
					<template v-slot:cell(actionButton)="row">
						<b-link :to="{path: '../delivery-list/delivery-list-details', query: { preSaleDeliveryRecordUuid : row.item.complainOrderUuid }}"
						    target="_blank">查看订单</b-link>
					</template>
				</b-table>
		</div>
	</div>
</template>

<script>
	import api from '@/api/api';
	import search from '@/libs/search';
	import HttpRequest from '@/libs/axios';
	import {
		formatDateTimeString,
		numberToFixed
	} from "@/libs/utils";
export default {
	name:'OrderComplaint',
	data(){
		return{
			showSpin: false,
			orderComplaintTab:{
				orderComplaintFields:[
					{
						key: "complainType",
						label: "类型"
					},
					{
						key: "complainSendTime",
						label: "发起时间"
					},
					{
						key: "complainOrderCode",
						label: "关联订单号"
					},
					{
						key: "complainResponsePerson",
						label: "回复人"
					},
					{
						key: "complainResponseTime",
						label: "回复时间"
					},
					{
						key: "complainResponse",
						label: "回复内容"
					},
					{
						key: "complainResult",
						label: "回复结果"
					},
					{
						key: "complainTips",
						label: "提示"
					},
					{
						key: "actionButton",
						label: "操作"
					}
				],
				complaintList:[],
				isTableBusy: false,
				complaintSearch: search.getSearchParams(),
				preSaleDeliveryRecordUuid:[],
			}
		}
	},
	mounted() {
		if (!this.checkMemberLogin()) {
			this.$router.push({
				name: 'MemberLogin'
			});
			return;
		};
		this.getComplainList();
	},
	methods:{
		formatDateTimeString,
		getComplainList(){
			this.showSpin = true;
			api.getComplainList({
				userUuid: this.getLoginCookieUuid()
			}).then(res => {
				if (res.code === 0) {
					this.orderComplaintTab.complaintList = res.data.records;
				}
			});
		},
	}
}
</script>

<style>
	.OrderComplaint-list{margin-top: 20px;}
	.OrderComplaint-list th {
		background-color: #efefef;
		height: 40px;
		line-height: 40px;
	}
	.OrderComplaint-list tr{text-align: center;background:#fafafa;}
	.OrderComplaint-list th{background:#fafafa;}
	.OrderComplaint-list td{font-size: 14px;}
	
	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
	}
	
	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}
	
	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}
	.table-sm td a {
		color: #00B151;
	}
	/* 页码 */
	.page-item.active .page-link{background-color: #1da25a;border: 1px solid #1da25a;}
	.modal-header{background-color: #1da25a;color: #fff;}
	.content{margin-top: 0px !important;}
</style>


// WEBPACK FOOTER //
// src/view/order-complaint/order-complaint.vue